export default class Header {
  constructor(element) {
    this.element = element;
    this.html = document.documentElement;
    this.body = document.body;
    this.trigger = this.element.querySelector('#mobile-trigger');
    this.menu = this.element.querySelector('.menu-links');
    this.menuListItems = this.element.querySelector('.menu-list-items');

    this.scrollThreshold = 10;

    this.init();
    this.initNavMobile();
  }

  init() {
    if (!this.element || !this.menuListItems) return;

    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const isDesktop = window.innerWidth > 1024;

      const targetClass = isDesktop ? "desktopfixed" : "mobiletopfixed";
      const wrongClass = isDesktop ? "mobiletopfixed" : "desktopfixed";

      if (scrollTop > this.scrollThreshold) {
        this.menuListItems.classList.add(targetClass);
        this.menuListItems.classList.remove(wrongClass);
      } else {
        this.menuListItems.classList.remove("desktopfixed", "mobiletopfixed");
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);
  }

  initNavMobile() {
    if (this.trigger && this.menu) {
      this.trigger.addEventListener("click", () => {
        const isActive = this.menu.classList.contains("active");

        this.trigger.classList.toggle("active");
        this.menu.classList.toggle("active");
        this.element.classList.toggle("menu-open");

        if (!isActive) {
          this.html.style.overflow = 'hidden';
          this.body.style.overflow = 'hidden';
        } else {
          this.html.style.overflow = '';
          this.body.style.overflow = '';
        }
      });
    }
  }
}